import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class RegionalCloseIcon extends BaseIcon {
    getChildren = () => {
        const color = this.getColor() === 'currentColor' ? '#8a98b4' : this.getColor()

        return [
            <path d="M10.738,9.513a.846.846,0,0,1,0,1.225h0a.846.846,0,0,1-1.225,0h0L7.5,8.725,5.487,10.738a.846.846,0,0,1-1.225,0h0a.846.846,0,0,1,0-1.225h0L6.275,7.5,4.263,5.487A.866.866,0,0,1,5.488,4.262L7.5,6.275,9.513,4.263a.866.866,0,0,1,1.225,1.225L8.725,7.5Z" transform="translate(-4 -4)" fill={color} opacity="0.582"/>        ]
    }
    getViewBox = () => '0 0 7 7'
}
